import { type PropsWithChildren as PWC } from 'react';

import {
    AuthProvider,
    type AuthProviderProps,
} from '@myphx-engineering/auth/client';

import { useAppSystemDegradationStatus } from '../hooks/use-app-system-degradation-status';

export const AppAuthProvider = ({
    children,
    ...authConfig
}: PWC<AuthProviderProps>) => {
    const { disableAuthFlows } = useAppSystemDegradationStatus();

    return (
        <AuthProvider {...authConfig} disableAuthFlows={disableAuthFlows}>
            {children}
        </AuthProvider>
    );
};
